// local development URL=================================================
// export const BASE_URL = 'http://localhost:4000';
// production URL
// export const BASE_URL = 'https://api.richesse.solutions';
export const BASE_URL = 'https://api.bitstekadvisory.com';
// export const BASE_URL = 'http://13.221.95.125';

//frontend base URL for referralID=======================================
// local development URL
// export const referral_BASE_URL = 'http://localhost:3000';
// production URL
// export const referral_BASE_URL = 'https://crm.richesse.solutions';
export const referral_BASE_URL = 'https://crm.bitstekadvisory.com';
// export const referral_BASE_URL = 'http://13.221.95.125';